import { render } from "./PublicationUsers.vue.js?vue&type=template&id=5ad4c585!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationUsers.vue?vue&type=template&id=5ad4c585"
import script from "./PublicationUsers.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationUsers.vue?vue&type=script&lang=js"
export * from "./PublicationUsers.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/PublicationUsers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ad4c585"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ad4c585', __exports__)) {
    api.reload('5ad4c585', __exports__)
  }
  
  module.hot.accept("./PublicationUsers.vue.js?vue&type=template&id=5ad4c585!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./PublicationUsers.vue?vue&type=template&id=5ad4c585", () => {
    api.rerender('5ad4c585', render)
  })

}


export default __exports__